<template>
  <b-modal
    ref="email"
    :id="modalId"
    @ok="sendEmail"
    size="lg"
    title="Envío de correo"
    :ok-disabled="loading"
    :cancel-disabled="loading"
  >
    <b-form-group>
      <label for="name">Para</label>
      <b-form-input :disabled="loading" type="text" v-model="to"></b-form-input>
    </b-form-group>

    <b-form-group v-if="cc !== ''">
      <label for="name">CC</label>
      <b-form-input :disabled="loading" type="text" v-model="cc"></b-form-input>
    </b-form-group>

    <b-form-group v-if="bcc !== ''">
      <label for="name">CCO</label>
      <b-form-input :disabled="loading" type="text" v-model="bcc"></b-form-input>
    </b-form-group>

    <b-form-group>
      <label for="name">Asunto</label>
      <b-form-input :disabled="loading" type="text" v-model="subject"></b-form-input>
    </b-form-group>

    <b-form-group>
      <label for="name">Mensaje</label>
      <b-form-textarea
        :disabled="loading"
        id="textarea"
        v-model="msg"
        placeholder="Enter something..."
        rows="3"
        max-rows="6"
      ></b-form-textarea>
    </b-form-group>
    <b-spinner v-if="loading"></b-spinner>
  </b-modal>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "EmailModal",
  components: {
    Multiselect
  },
  props: {
    modalId: {
      type: String,
      default: "email-modal"
    },
    to: {
      type: String,
      default: ""
    },
    cc: {
      type: String,
      default: ""
    },
    bcc: {
      type: String,
      default: ""
    },
    msg: {
      type: String,
      default: ""
    },
    subject: {
      type: String,
      default: ""
    },
    ep_url: {
      type: String,
      default: ""
    },
    item: {
      type: Object,
      default: () => {}
    },
    method: {
      type: String,
      default: "post"
    }
  },
  data() {
    return {
      loading: false
    };
  },

  methods: {
    sendEmail(bvModalEvent) {
      this.loading = true;
      // Prevent modal from closing
      bvModalEvent.preventDefault();
      this.$axios({
        method: this.method,
        url: this.ep_url + this.item.id,
        params: {
          to: this.to,
          cc: this.cc,
          bcc: this.bcc,
          subject: this.subject,
          msg: this.msg
        }
      })
        .then((res) => {
          this.$emit("onSend", res.data);
          this.$bvModal.hide(this.modalId);
          this.$bvToast.toast("Correo enviado", {
            title: "Correo enviado",
            variant: "success",
            solid: true
          });
        })
        .catch((error) => {
          console.log(error);
          this.$bvToast.toast("Error al enviar correo", {
            title: "Error",
            variant: "danger",
            solid: true
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.form-control .multislelect__input {
}
.multislelect__tags {
  font-size: 11px;
}
</style>
